export class GeoCoord {

    constructor(lat: number = null, lon: number = null) {
        this.latitude = lat;
        this.longitude = lon;
    }

    latitude: number;
    longitude: number;
};